<template>
  <div class="exceptionHandling">
    <el-form :inline="true" :model="searchForm" class="demo-form-inline" label-width="90px">
      <el-form-item label="设备名称" label-width="70px">
        <el-select v-model="searchForm.marchineId" placeholder="请选择" style="width: 100%">
          <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="药房" label-width="70px">
        <DicInput @fieldId="fieldId($event,'pharmacyId')" :dicType="8"></DicInput>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="searchForm.status" placeholder="请选择" style="width: 100%">
          <el-option label="等待处理" value="0"></el-option>
          <el-option label="已分配" value="1"></el-option>
          <el-option label="已处理" value="2"></el-option>
          <el-option label="已经评价" value="3"></el-option>
          <el-option label="已关闭" value="99"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div style="margin-bottom: 20px">
      <el-button type="primary" @click="search">查询<i class="el-icon-search el-icon--right"></i></el-button>
      <el-button type="info" @click="clear">重置<i class="el-icon-refresh-right el-icon--right"></i></el-button>
    </div>
    <div style="border: 1px solid #c9cdd6">
      <el-table
          :header-cell-style="{background:'#F5F5F5'}"
          :data="tableData"
          max-height="600"
          style="width: 100%"
      >
        <el-table-column
            prop="createDate"
            label="上报时间"
            min-width="70">
        </el-table-column>
        <el-table-column
            prop="exceptionTypeName"
            label="异常类型名称"
            min-width="70">
        </el-table-column>
        <el-table-column
            prop="deviceName"
            label="机器名称"
            align="center">
        </el-table-column>
        <el-table-column
            prop="deviceName"
            label="药房"
            align="center">
        </el-table-column>
        <el-table-column
            prop="dealDate"
            align="center"
            label="处理时间">
        </el-table-column>
        <el-table-column
            prop="dealEvaluation"
            align="center"
            label="处理评价">
        </el-table-column>
        <el-table-column
            prop="workerName"
            align="center"
            label="处理人">
        </el-table-column>
        <el-table-column
            prop="deallevel"
            align="center"
            label="服务态度星级">
          <template slot-scope="scope">
            <el-rate
                v-model="scope.row.deallevel"
                disabled
                text-color="#ff9900">
            </el-rate>
          </template>
        </el-table-column>
        <el-table-column
            prop="timelinessLevel"
            align="center"
            label="及时性星级">
          <template slot-scope="scope">
            <el-rate
                v-model="scope.row.timelinessLevel"
                disabled
                text-color="#ff9900">
            </el-rate>
          </template>
        </el-table-column>
        <el-table-column
            prop="technicalLevel"
            align="center"
            label="技术水平星级">
          <template slot-scope="scope">
            <el-rate
                v-model="scope.row.technicalLevel"
                disabled
                text-color="#ff9900">
            </el-rate>
          </template>
        </el-table-column>
        <!-- <el-table-column
            prop="dealContent"
            align="center"
            label="处理经过描述">
        </el-table-column> -->
        <el-table-column
            prop="status"
            align="center"
            label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status===0">
             等待处理
            </span>
            <span v-if="scope.row.status===1">
             已分配
            </span>
            <span v-if="scope.row.status===2">
              已处理
            </span>
            <span v-if="scope.row.status===3">
              已评价
            </span>
            <span v-if="scope.row.status===3">
             已关闭
            </span>
          </template>
        </el-table-column>
        <el-table-column
            prop="note"
            align="center"
            label="备注">
        </el-table-column>
        <el-table-column
            prop="note"
            align="center"
            label="操作">
          <template slot-scope="scope">
            <el-button @click="handlingClick(scope.row)" type="text" size="small" v-if="scope.row.status===1">异常处理</el-button>
            <el-button v-if="scope.row.status===0||scope.row.status===1" @click="arrangeClick(scope.row)" type="text"
                       size="small">分配工人
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div style="margin-top: 20px">
      <Pagination :total='total' :currentPage='currPage' :pageSize='pageSize' @handleSizeChange='handleSizeChange'
                  @handleCurrentChange='handleCurrentChange'></Pagination>
    </div>
    <el-dialog
        title="分配工人"
        :close-on-click-modal="false"
        :visible.sync="workersDialog"
        width="30%">
      <el-form :model="workerForm" ref="workerForm" label-width="110px" class="demo-ruleForm">
<!--     <el-form-item label="工人姓名" required>
          <DicInput style="width: 100%" :initName="workerForm.workerName"
                    @fieldId="workersFormfieldId($event,'dealById')"
                    :url="'api/Worker/Workers'"></DicInput>
        </el-form-item> -->
       
        <el-form-item  label="工人姓名" required>
          <el-select v-model="workerForm.workerName" @change="workerchange" filterable placeholder="请选择">
    <el-option
      v-for="item in workeroptions"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
        </el-form-item>

        <el-form-item label="工人电话" required>
          <el-input clearable v-model="workerForm.phone" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="计划日期" required>
          <el-date-picker
              value-format="yyyy-MM-dd"
              v-model="workerForm.planDate"
              type="date"
              placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
    <el-button @click="workersDialog = false">取 消</el-button>
    <el-button type="primary" @click="workersForm('workerForm')">确 定</el-button>
  </span>
    </el-dialog>
    <el-dialog
        title="处理异常"
        :close-on-click-modal="false"
        :visible.sync="dealDialog"
        width="30%">
      <el-form :model="dealData" ref="dealForm" class="demo-ruleForm">
        <el-form-item label="处理描述" required>
          <el-input type="textarea" :rows="4" clearable v-model="dealData.dealContent" placeholder="请输入"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
    <el-button @click="dealDialog = false">取 消</el-button>
    <el-button type="primary" @click="deal('dealForm')">确 定</el-button>
  </span>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination.vue';
import DicInput from '@/components/DicInput.vue';
import {GetUrl} from "@/service/common";

export default {
  name: "exceptionHandling",
  data() {
    return {
      tableData: [],
      searchForm: {
        marchineId: '',
        status: '0',
        pharmacyId: '',
      },
      total: 0, //总条数
      currPage: 1,//当前页码
      pageSize: 10, //每页条数
      colors: ['#99A9BF', '#F7BA2A', '#FF9900'], // 等同于 { 2: '#99A9BF', 4: { value: '#F7BA2A', excluded: true }, 5: '#FF9900' }
      form: {
        dealEvaluation: '',
        isclose: 1,
        deallevel: 0
      },
      workersDialog: false,
      dealDialog: false,
      workerForm: {
        "workerName": "",
        "workNumber": "",
        "dealById": 0,
        "phone": "",
        "planDate": 0
      },
      dealData:{
        id:'',
        dealContent:'',
      },
      rules: [],
      userJson: {},
      options: [],
      workers:[],
      workeroptions:[],
      evaluatioId: ''
    }
  },
  components: {
    //someComponent
    Pagination,
    DicInput
  },
  created() {
    this.userJson = window.utils.storage.getter('userJson')
  },
  methods: {
    //搜索
    search() {
      this.currPage = 1 //当前页码
      this.pageSize = 10 //每页条数
      this.init()
    },
    clear() {
      this.searchForm = {
        pharmacyId: '',
        marchineId: '',
        status: '0'
      }
      this.init()
    },
    // 评价
    // ----------分页控制-------------
    handleSizeChange(val) {
      this.pageSize = val
      this.init()
    },
    handleCurrentChange(val) {
      this.currPage = val
      this.init()
    },
    // 字典
    fieldId(item, name) {
      if (item.id) {
        this.searchForm[name] = item.id
      } else {
        this.searchForm[name] = ''
      }
    },
    workersFormfieldId(item, name) { // 分配工人id
      if (item.id) {
        this.workerForm[name] = item.id
        this.workerForm.workerName = item.name
        this.workerForm.workNumber = item.code
        this.workerForm.phone = item.phone
      } else {
        this.workerForm[name] = ''
      }
    },
    workerchange(id)
    {
      if (id) {
        var worker=this.workers.find(m=>m.id==id)
        this.workerForm[name] = worker.id
        this.workerForm.workerName = worker.name
        this.workerForm.workNumber = worker.code
        this.workerForm.phone = worker.phone
      } else {
        this.workerForm[name] = ''
      }
    },
    arrangeClick(row) {
      this.workersList = row
      this.workersDialog = true
      this.workerForm = {
        "workerName": "",
        "workNumber": "",
        "dealById": 0,
        "phone": "",
        "planDate": ''
      }
    },
    workersForm(formName) { // 分配工人
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            ...this.workerForm
          }
          this.axios
              .put("api/ExceptionRecord/ArrangeWorker?id=" + this.workersList.id, data).then((res) => {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.$refs[formName].resetFields();
            this.workersDialog = false
            this.init()
          })
        } else
          return false;
      })
    },
    handlingClick(row){ // 异常处理
      this.dealData.id=row.id
      this.dealData.dealContent=''
      this.dealDialog=true
    },
    deal(formName) { // 异常处理提交
      this.$refs[formName].validate((valid) => {
        if (!valid) return;
        else {
          this.axios
              .put("api/ExceptionRecord/deal?id=" + this.dealData.id + '&dealContent='+ this.dealData.dealContent,this.dealData).then((res) => {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.$refs[formName].resetFields();
            this.dealDialog = false
            this.init()
          })
        }
      })
    },
    //弹窗模块
    handleClose(done) {
      this.$confirm('确认关闭？')
          .then(_ => {
            done();
            this.$refs['ruleForm'].resetFields();
          })
    },
    // list
    init() {
      let data = {
        ...this.searchForm,
        pharmacyId: this.userJson.pharmacyId,
        page: this.currPage,
        pageSize: this.pageSize,
      }
      this.axios
          .get("api/ExceptionRecord", {params: data})
          .then((res) => {
            this.tableData = res.list
            this.total = res.count
          })
    },
    // 设备列表
    equipmentinit() {
      let data = {
        pageSize: '20000',
        page: '1',
      }
      this.axios
          .get("api/Device/GetWithPage", {params: data}).then((res) => {
        let list = res.list
        list.forEach(item => {
          let obj = {
            value: item.id,
            label: item.name
          }
          this.options.push(obj)
        })
      })
    },
    workersinit(){
      this.axios
          .get("api/Worker/Workers").then((res) => {
        let list = res.list
        this.workers=list
        list.forEach(item => {
          let obj = {
            value: item.id,
            label: item.name,
            item
          }
          this.workeroptions.push(obj)
        })
      })
    },

  },
  mounted() {
    //
    this.init()
    this.equipmentinit()
    this.workersinit()
  }
}
</script>

<style lang="scss" scoped>
.exceptionHandling {

}
</style>